import * as React from 'react';

import { FilterMenu } from '../common/filter/filter-menu.presentation';
import { Pagination } from '../common/pagination/pagination.component';
import { CategoryCard } from './category-card.presentation';
import { CategoryItem } from './category-item.presentation';

export const CategoriesList = ({ loading, items, limit, page, total, setPage, selectCategory, view, changeView }) => {
    if (loading) {
        return (<div style={{ padding: 200 }}>
            <div className='ui active inverted dimmer'>
                <div className='ui massive text loader'>Loading</div>
            </div>
        </div>);
    }
    else if (items.length === 0) {
        return (<div className='container'><h2>No categories available</h2></div>);
    }

    const css = 'ui ' + view + (view === 'cards' ? ' six doubling' : '');

    return (<div className='container'>
        <FilterMenu doRefresh={null} view={view} changeView={changeView} />
        <div className={css}>
            {items.map(item => {
                if (view === 'cards') {
                    return <CategoryCard key={item._id} category={item} selectCategory={selectCategory} />;
                }
                else {
                    return <CategoryItem key={item._id} category={item} selectCategory={selectCategory} />;
                }
            })}
        </div>
        <Pagination limit={limit} total={total} currentPage={page} selectPage={setPage} />
    </div>);
};



// WEBPACK FOOTER //
// ./src/components/categories/categories-list.presentation.tsx